import { render, staticRenderFns } from "./BulkUpdateDescriptionDialog.vue?vue&type=template&id=7438de53&scoped=true"
import script from "./BulkUpdateDescriptionDialog.ts?vue&type=script&lang=ts&external"
export * from "./BulkUpdateDescriptionDialog.ts?vue&type=script&lang=ts&external"
import style0 from "./BulkUpdateDescriptionDialog.scss?vue&type=style&index=0&id=7438de53&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7438de53",
  null
  
)

export default component.exports